import script from "./UtmPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./UtmPreview.vue?vue&type=script&setup=true&lang=js"

import "./UtmPreview.vue?vue&type=style&index=0&id=50654a62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50654a62"]])

export default __exports__